import type { AppProps } from 'next/app'
import '../style/style.css'

function CafApp({ Component, pageProps }: AppProps) {
  return <Component {...pageProps} />
}

export default CafApp
